import * as React from "react";
import "./CPCountBadge.scss";

export interface CPCountBadgeProps {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  title?: string;
}

/**
 * Standalone inline count badge rendered as a plain pill span.
 * Sits naturally in flex/inline contexts without Kendo's overlay positioning.
 */
const CPCountBadge: React.FC<CPCountBadgeProps> = ({
  children,
  className,
  style,
  title,
}) => (
  <span
    className={["cp-count-badge", className].filter(Boolean).join(" ")}
    style={style}
    title={title}
  >
    {children}
  </span>
);

export default CPCountBadge;
